import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Browser extensions (e.g. MetaMask) inject scripts into every page; their
// errors bubble to window and trip the CRA dev-error overlay even though
// they have nothing to do with this app. Swallow anything originating from
// an extension so the overlay only shows real app errors.
window.addEventListener('error', (event) => {
  if (event.filename && event.filename.startsWith('chrome-extension://')) {
    event.stopImmediatePropagation();
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const stack = event.reason?.stack || '';
  if (stack.includes('chrome-extension://')) {
    event.stopImmediatePropagation();
  }
});

// Add Google Fonts
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);